export default {
    state: {},
    mutations: {
        modalClose(state, modalName) {
            state[modalName] = false;
        },
        modalOpen(state, modalName) {
            state[modalName] = true;
        },
        initModal(state, modalName) {
            console.log(state);
            state[modalName] = false;
        }
    }
}